import { compileProducts } from '@/js/analytics/utils'
import { STATUS_CART, SEND_EVENT } from '@/js/analytics/const'
import { storage } from '@utils/session-storage'

export default function sendStatusCart(cart) {
  console.log('sendStatusCart', cart);
  if ('undefined' === typeof window.eS) return false
  cart.forEach(element => {
    const products = compileProducts(element)
    if (element.shop) {
      storage.setItem(`shop_cart_${element.shop.id}`, element.GUID)
    }
    console.log({ [STATUS_CART]: products, GUID: element.GUID });
    // eslint-disable-next-line no-undef
    eS(SEND_EVENT, STATUS_CART, {
      [STATUS_CART]: products,
      GUID: element.GUID,
    })
  })
  return false
}

export function analyticCartAdd(
  name, id, price, quantity
) {
  console.log(name, id, price, quantity);
  // if (!window.is_analytic_enabled) return
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      items: [{
        item_name: name,
        item_id: id,
        price,
        quantity,
      }],
    },
  })
}
export function analyticCartRemove(
  name, id, price, quantity
) {
  console.log(name, id, price, quantity);
  // if (!window.is_analytic_enabled) return
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      items: [{
        item_name: name,
        item_id: id,
        price,
        quantity,
      }],
    },
  })
}
